import { PortfolioFilterType } from '../../enums/PortfolioFilterType';
import { Action } from '../../types/Action';
import { FilterItemResource, MinMaxFilter } from '../../types/FilterTypes';
import { NoteResource, NotesCountMap } from '../../types/Note';
import {
  PortfolioFilterResource,
  PortfolioSelectedFilterResource,
} from '../../types/PortfolioFilterResource';
import { PortfolioRequestResource } from '../../types/PortfolioRequestResource';
import { PrivateIncentiveModalResource } from '../../types/PrivateIncentiveModalResource';

export enum PortfolioActionsType {
  SET_PORTFOLIO_FILTERS = 'Set portfolio filters',
  SET_PORTFOLIO_SELECTED_FILTERS = 'Set portfolio selected filters',
  SET_PORTFOLIO_MASTER_FILTER = 'Set portfolio Master Filter',
  SET_IS_PORTFOLIO_FILTERS_CHANGED = 'Set portfolio is filter changed',
  SET_PORTFOLIO_REQUEST_RESOURCE = 'Set portfolio request resource',
  SET_PORTFOLIO_DATA_TOTAL_COUNT = 'Set portfolio data total count',
  SET_PORTFOLIO_SHOULD_REFRESH = 'Should portfolio refresh',
  SET_PORTFOLIO_SHOULD_REFRESH_DEAL_COUNT = 'Should portfolio refresh deal count',
  SET_PORTFOLIO_IS_LOADING = 'Set is portfolio loading',
  SET_PORTFOLIO_DEFAULT_BPS_VALUE = 'Set portfolio default bps value',
  SET_PORTFOLIO_DEFAULT_IN_MARKET_SCORE_VALUE = 'Set portfolio default in market score value',
  SET_PORTFOLIO_DEFAULT_VEHICLE_SCORE_VALUE = 'Set portfolio default vehicle score value',
  SET_PORTFOLIO_DEFAULT_DEAL_SCORE_VALUE = 'Set portfolio default deal score value',
  SET_PORTFOLIO_DEFAULT_LAST_UPDATED = 'Set portfolio default last updated',
  SET_PORTFOLIO_CURRENT_DEAL_TYPE = 'Set portfolio current deal type',
  SET_PORTFOLIO_OPTIONS = 'Set portfolio options',
  SET_PORTFOLIO_CURRENT_STORE_ID = 'Set portfolio current store id',
  SET_PORTFOLIO_UPDATED_NOTES_COUNT = 'Set portfolio updated notes count',
  SET_PORTFOLIO_NOTES_COUNT_MAP = 'Set portfolio notes count map',
  SET_IS_PORTFOLIO_BULKPRINT_INPROGRESS = 'Set is bulk print from portfolio in progress',
  SET_IS_PORTFOLIO_BULKEXPORT_INPROGRESS = 'Set is bulk export from portfolio in progress',
  SET_IS_PORTFOLIO_FILTER_RESET = 'Set is portfolio filter reset',
  SET_OPEN_FILTER_COUNT = 'Set open filter count',
  SET_PORTFOLIO_NOTES_MODAL_OPEN = 'Set portfolio notes modal open',
  SET_PORTFOLIO_MODAL_RESOURCE = 'Set portfolio notes modal resource',
  SET_PRIVATE_INCENTIVE_MODAL_OPEN = 'Set private incentive modal open',
  SET_PRIVATE_INCENTIVE_MODAL_RESOURCE = 'Set private incentive modal resource',
  SET_LEFT_MOBILE_MENU = 'Set left mobile menu show/hide',
  SET_PORTFOLIO_ResetPaginator = 'Set portfolio load from dropdown',
}

export const setIsPortfolioFiltersChanged = (value: boolean, dealType: string): Action => ({
  type: PortfolioActionsType.SET_IS_PORTFOLIO_FILTERS_CHANGED,
  payload: { value: value, dealType: dealType },
});

export const setPortfolioRequestResource = (
  requestBody: PortfolioRequestResource,
  dealType: string,
): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_REQUEST_RESOURCE,
  payload: { requestBody: requestBody, dealType: dealType },
});

export const setPortfolioDataTotalCount = (value: number, dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_DATA_TOTAL_COUNT,
  payload: { value: value, dealType: dealType },
});

export const setPortfolioShouldRefresh = (value: boolean, dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_SHOULD_REFRESH,
  payload: { value: value, dealType: dealType },
});

export const setPortfolioShouldRefreshDealCount = (value: boolean, dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_SHOULD_REFRESH_DEAL_COUNT,
  payload: { value: value, dealType: dealType },
});

export const setIsPortfolioLoading = (value: boolean): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_IS_LOADING,
  payload: value,
});

export const updateMasterFilterKey = (key: PortfolioFilterType, dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_MASTER_FILTER,
  payload: { key: key, dealType: dealType },
});

export const updateSelectedFilters = (
  filters: PortfolioSelectedFilterResource,
  dealType: string,
): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_SELECTED_FILTERS,
  payload: { filters: filters, dealType: dealType },
});

export const setPortfolioFilters = (
  filters: PortfolioFilterResource,
  dealType: string,
): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_FILTERS,
  payload: { filters: filters, dealType: dealType },
});

export const setDefaultBpsValue = (value: MinMaxFilter<number>, dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_DEFAULT_BPS_VALUE,
  payload: { value: value, dealType: dealType },
});

export const setDefaultInMarketScoreValue = (
  value: MinMaxFilter<number>,
  dealType: string,
): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_DEFAULT_IN_MARKET_SCORE_VALUE,
  payload: { value: value, dealType: dealType },
});
export const setDefaultVehicleScoreValue = (
  value: MinMaxFilter<number>,
  dealType: string,
): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_DEFAULT_VEHICLE_SCORE_VALUE,
  payload: { value: value, dealType: dealType },
});
export const setDefaultDealScoreValue = (
  value: MinMaxFilter<number>,
  dealType: string,
): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_DEFAULT_DEAL_SCORE_VALUE,
  payload: { value: value, dealType: dealType },
});
export const setDefaultLastUpdated = (value: MinMaxFilter<number>, dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_DEFAULT_LAST_UPDATED,
  payload: { value: value, dealType: dealType },
});

export const setCurrentDealType = (value: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_CURRENT_DEAL_TYPE,
  payload: value,
});

export const setPortfolioOptions = (value: FilterItemResource[]): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_OPTIONS,
  payload: value,
});

export const setPortfolioStoreId = (value: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_CURRENT_STORE_ID,
  payload: value,
});

export const setPortfolioUpdatedNotesCount = (value: NotesCountMap, dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_UPDATED_NOTES_COUNT,
  payload: { value: value, dealType: dealType },
});

export const setPortfolioNotesCountMap = (value: NotesCountMap[], dealType: string): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_NOTES_COUNT_MAP,
  payload: { value: value, dealType: dealType },
});

export const setIsPortfolioBulkPrintInPorgress = (
  isPortfolioBulkPrintInPorgress: boolean,
): Action => ({
  type: PortfolioActionsType.SET_IS_PORTFOLIO_BULKPRINT_INPROGRESS,
  payload: isPortfolioBulkPrintInPorgress,
});

export const setIsPortfolioBulkExportInPorgress = (
  isPortfolioBulkExportInPorgress: boolean,
): Action => ({
  type: PortfolioActionsType.SET_IS_PORTFOLIO_BULKEXPORT_INPROGRESS,
  payload: isPortfolioBulkExportInPorgress,
});

export const setIsPortfolioFilterReset = (isPortfolioFilterReset: boolean): Action => ({
  type: PortfolioActionsType.SET_IS_PORTFOLIO_FILTER_RESET,
  payload: isPortfolioFilterReset,
});

export const setOpenFilterCount = (openFilterCount: number): Action => ({
  type: PortfolioActionsType.SET_OPEN_FILTER_COUNT,
  payload: openFilterCount,
});

export const setPortfolioNotesModalOpen = (isNotesModalOpen: boolean): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_NOTES_MODAL_OPEN,
  payload: isNotesModalOpen,
});

export const setLeftMobileMenu = (value: boolean): Action => ({
  type: PortfolioActionsType.SET_LEFT_MOBILE_MENU,
  payload: value,
});

export const setPortfolioNotesModalResource = (notesModalResource: NoteResource): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_MODAL_RESOURCE,
  payload: notesModalResource,
});

export const setPrivateIncentiveModalOpen = (isPrivateIncentiveModalOpen: boolean): Action => ({
  type: PortfolioActionsType.SET_PRIVATE_INCENTIVE_MODAL_OPEN,
  payload: isPrivateIncentiveModalOpen,
});

export const setPrivateIncentiveModalResource = (
  privateIncentiveModalResource: PrivateIncentiveModalResource,
): Action => ({
  type: PortfolioActionsType.SET_PRIVATE_INCENTIVE_MODAL_RESOURCE,
  payload: privateIncentiveModalResource,
});

export const setIsPortfolioResetPaginator = (isPortfolioResetPaginator: boolean): Action => ({
  type: PortfolioActionsType.SET_PORTFOLIO_ResetPaginator,
  payload: isPortfolioResetPaginator,
});

export type PortfolioActions = ReturnType<
  | typeof setIsPortfolioFiltersChanged
  | typeof setPortfolioRequestResource
  | typeof setPortfolioDataTotalCount
  | typeof setPortfolioShouldRefresh
  | typeof setPortfolioShouldRefreshDealCount
  | typeof setIsPortfolioLoading
  | typeof updateMasterFilterKey
  | typeof updateSelectedFilters
  | typeof setPortfolioFilters
  | typeof setDefaultBpsValue
  | typeof setCurrentDealType
  | typeof setPortfolioOptions
  | typeof setPortfolioStoreId
  | typeof setPortfolioUpdatedNotesCount
  | typeof setPortfolioNotesCountMap
  | typeof setIsPortfolioBulkPrintInPorgress
  | typeof setIsPortfolioBulkExportInPorgress
  | typeof setIsPortfolioFilterReset
  | typeof setOpenFilterCount
  | typeof setPortfolioNotesModalOpen
  | typeof setPortfolioNotesModalResource
  | typeof setPrivateIncentiveModalOpen
  | typeof setPrivateIncentiveModalResource
  | typeof setLeftMobileMenu
  | typeof setIsPortfolioResetPaginator
>;
